import { Component, Input, OnInit }  from '@angular/core';
import { FormGroup }                 from '@angular/forms';

import { ElementControlService }    from './elements/elementControl.service';
import { ElementBase } from './elements/elementBase';

@Component({
  selector: 'dynamic-form',
  templateUrl: './dynamicForm.component.html',
  providers: [ ElementControlService ]
})
export class DynamicFormComponent implements OnInit {

  @Input() campos: ElementBase<any>[] = [];
  form: FormGroup;
  payLoad = '';

  constructor(private ecs: ElementControlService) {  }

  ngOnInit() {
    this.form = this.ecs.toFormGroup(this.campos);
  }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.value);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/form/dynamicForm.component.ts